






















































































// @ts-nocheck
let map: any;
const zoom = 14;
const handler: any = [];
let img: any;

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { doublePrevention, performanceServer } from '@/api/installServer';
import { arrayToTree } from '@/util/array';
import { videoManagement } from '@/api/installServer';
import mapMarkers from '@/components/mapTools/mapMarkers.vue';

@Component({
  components: { mapMarkers },
})
export default class PublicProp extends Vue {
  @Prop(Object) rowId: any;
  private visible = false;
  private title = '';
  private isDisabled = false;
  private detailShow = false;
  private formData: any = {
    aliasVideoName: '', // 视频别名
    areaId: '', // 区域id
    areaName: '', // 区域名称
    brand: '海康', // 视频品牌
    id: '', // 视频别名
    isShowMap: false, // 是否在地图上显示
    latitude: '', // 纬度
    longitude: '', // 经度
    videoIndexCode: '', // 视频Code
    videoName: '', // 视频名称
    resourceName: '', // 资源名称 *
  };
  private videoAreaId: any = ''; // 视频区域id
  private videoAreaName: any = ''; // 视频区域名称
  private formRules: any = {
    videoIndexCode: [{ required: true, message: '请选择视频', trigger: 'blur' }],
    videoName: [{ required: true, message: '请输入视频名称', trigger: 'blur' }],
    areaId: [{ required: true, message: '请选择区域', trigger: 'blur' }],
  };
  private spaceAreaList: any = []; // 区域的下拉

  private videoAreaList: any = []; // 视频区域
  private cameraList: any = []; // 视频区域
  private pointArr: any = []; // 经纬度
  private keyValue: any = 0;

  img_nj: any;
  img_jzs: any;
  index: any = 0;

  private showDialog() {
    this.getVideoArea();
    this.getSpaceAreaData(); // 区域列表
    switch (this.rowId.type) {
      case 'add':
        this.title = '添加视频点';
        this.detailShow = false;
        break;
      case 'edit':
        this.title = '编辑视频点';
        this.getVideoDetail();
        this.detailShow = false;
        break;
      case 'detail':
        this.title = '视频点详情';
        this.getVideoDetail();
        this.isDisabled = true;
        this.detailShow = true;
        setTimeout(() => {
          this.$nextTick(() => {
            this.showMap();
          });
        }, 300);
        break;
    }
    this.visible = true;
  }

  @Watch('spaceAreaList')
  private checkedScroll() {
    this.keyValue++;
  }

  private hideDialog() {
    this.spaceAreaList = [];
    this.videoAreaList = []; // 视频区域
    this.cameraList = []; // 视频区域
    this.pointArr = []; // 经纬度
    this.videoAreaId = ''; // 视频区域id
    this.videoAreaName = ''; // 视频区域名称
    this.detailShow = false;
    setTimeout(() => {
      this.$emit('hideDialog');
      this.isDisabled = false;
      // (this.$parent as any).getData();
    }, 300);
    this.clearForm();
  }

  private submitForm() {
    // console.log(this.formData)
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (valid) {
        if (this.rowId.type === 'edit') {
          // 编辑的保存
          this.putVideo();
          this.hideDialog();
        } else {
          // 新增的保存
          this.addVideo();
          this.hideDialog();
        }
      }
    });
  }

  // 详情
  private getVideoDetail() {
    videoManagement.getVideoDetail(this.rowId.data.id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        if (this.formData.longitude && this.formData.latitude) {
          this.pointArr = [
            {
              lat: this.formData.latitude,
              lng: this.formData.longitude,
            },
          ];
        }
        if (res.data.videoInfoBody) {
          // console.log(123,JSON.parse(res.data.videoInfoBody));
          let obj: any = {};
          obj = JSON.parse(res.data.videoInfoBody);
          this.videoAreaId = obj.regionIndexCode ? obj.regionIndexCode : '';
          this.videoAreaName = obj.regionName ? obj.regionName : '';
          if (this.videoAreaId) {
            this.getCameraData();
          }
        }
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  // 编辑
  private putVideo() {
    videoManagement
      .putVideo(this.rowId.data.id, {
        ...this.formData,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功编辑了该条数据！');
        } else {
          this.$message.warning(res.msg);
        }
      });
  }

  // 新增
  private addVideo() {
    videoManagement
      .addVideo({
        ...this.formData,
      })
      .then((res: any) => {
        // console.log(res);
        if (res.code === '200') {
          this.$message.success('成功添加了一条数据！');
        } else {
          this.$message.warning(res.msg);
        }
      });
  }

  private clearForm() {
    // for (const key in this.formData) {
    //     this.$set(this.formData, key, '');
    // }
    this.formData = {
      aliasVideoName: '', // 视频别名
      areaId: '', // 区域id
      areaName: '', // 区域名称
      brand: '海康', // 视频品牌
      id: '', // 视频别名
      isShowMap: false, // 是否在地图上显示
      latitude: '', // 纬度
      longitude: '', // 经度
      videoIndexCode: '', // 视频Code
      videoName: '', // 视频名称
    };
    this.visible = false;
  }

  // 区域列表
  getSpaceAreaData() {
    doublePrevention.getSpaceAreaData({}).then((res: any) => {
      if (res.code === '200') {
        this.spaceAreaList = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }

  // 选择区域
  getRiskData(name: any) {
    if (name && name.length > 0) {
      this.formData.areaId = name[name.length - 1];
    }
  }

  // 获取视频区域
  private getVideoArea() {
    videoManagement
      .HKRegionList({})
      .then((res: any) => {
        this.videoAreaList = res.data;
      })
      .catch((error: any) => {
        this.$message.warning('获取数据失败！');
      });
  }
  // 视频区域选择改变
  private getVideoAreaId(data: any) {
    this.formData.resourceName = '';
    this.formData.videoIndexCode = '';
    this.formData.videoName = '';
    this.cameraList = [];
    if (data) {
      let selectedName: any = {};
      selectedName = this.videoAreaList.find((item: any) => {
        return item.name === data;
      });
      this.videoAreaId = selectedName.indexCode;
      this.getCameraData();
    } else {
      this.videoAreaId = '';
    }
  }

  // 获取视频列表
  private getCameraData() {
    videoManagement
      .HKCameraList({
        regionIndexCodes: this.videoAreaId ? this.videoAreaId : '',
      })
      .then((res: any) => {
        this.cameraList = res.data;
      })
      .catch((error: any) => {
        this.$message.warning('获取视频数据失败！');
      });
  }
  //
  private getCameraId(data: any) {
    this.formData.videoName = data;
    const selectedName = this.cameraList.find((item: any) => {
      return item.name === data;
    });
    this.formData.videoIndexCode = selectedName.indexCode;
  }

  private openMap() {
    const refName = 'mapMarkers';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(this.pointArr);
  }

  getMapPoint(data: any) {
    if (data.length > 0) {
      this.formData.longitude = data[0].lng;
      this.formData.latitude = data[0].lat;
      this.pointArr = data;
    } else {
      this.formData.longitude = '';
      this.formData.latitude = '';
      this.pointArr = [];
    }
  }

  showMap() {
    const imageURL = 'http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=4c3a4b8cec3d4af47a12cdd192ce35cb';
    //创建自定义图层对象
    const lay = new T.TileLayer(imageURL, { minZoom: 13, maxZoom: 18 });
    map = new T.Map('MapDiv', { layers: [lay] });
    // console.log(map);
    if (this.pointArr && this.pointArr.length > 0 && this.pointArr[0].lat && this.pointArr[0].lng) {
      map.centerAndZoom(new T.LngLat(this.pointArr[0].lng, this.pointArr[0].lat), zoom);
    } else {
      map.centerAndZoom(new T.LngLat(104.14872, 30.68284), zoom);
    }

    const typeArr: any = [
      {
        // title: '卫星',
        title: '',
        icon: ' http://api.tianditu.gov.cn/v4.0/image/map/maptype/satellite.png',
        layer: TMAP_SATELLITE_MAP,
      },
      {
        // title: '地图', //地图控件上所要显示的图层名称
        title: '', //地图控件上所要显示的图层名称
        icon: 'http://api.tianditu.gov.cn/v4.0/image/map/maptype/vector.png', //地图控件上所要显示的图层图标（默认图标大小80x80）
        layer: TMAP_NORMAL_MAP, //地图类型对象，即MapType。
      },
    ];
    const ctrl = new T.Control.MapType(typeArr);
    //添加控件
    map.addControl(ctrl);

    map.addEventListener('maptypechange', (e: any) => {
      console.log(e);
      //e.mapType 就是 当前切换的MapType 配置的地图
      if (e.mapType.name == 'TMAP_NORMAL_MAP') {
        // 普通地图 覆盖图隐藏
        this.img_nj.hide();
        this.img_jzs.hide();
      } else {
        this.img_nj.show();
        this.img_jzs.show();
      }
    });

    map.setMinZoom(13);
    map.setMaxZoom(18);

    // map.setMaxBounds(new T.LngLatBounds(new T.LngLat(104.62, 30.12), new T.LngLat(104.74, 30.24)));

    this.setMapImg();

    this.pointArr &&
      this.pointArr.forEach((item: any) => {
        const marker = new T.Marker(new T.LngLat(item.lng, item.lat));
        //向地图上添加标注
        map.addOverLay(marker);
      });

    const config = {
      showLabel: true,
      color: '#f14343',
      weight: 2,
      opacity: 1,
      fillColor: '#f14343',
      fillOpacity: 0.2,
    };
    //创建标注工具对象
    const polygonTool = new T.PolygonTool(map, config);
    this.$forceUpdate();
  }

  setMapImg() {
    const bd = new T.LngLatBounds(new T.LngLat(104.5548, 22.8871), new T.LngLat(104.5648, 22.8924));
    this.img_jzs = new T.ImageOverlay('map/img/map-s-jzs.png', bd, {
      opacity: 1,
      alt: '', // 名称
    });
    map.addOverLay(this.img_jzs);

    const bd_nj = new T.LngLatBounds(new T.LngLat(104.5573, 22.8752), new T.LngLat(104.5773, 22.8856));
    this.img_nj = new T.ImageOverlay('map/img/map-s-nj.png', bd_nj, {
      opacity: 1,
      alt: '', // 名称
    });
    map.addOverLay(this.img_nj);
  }
}
